import type { IndexRange } from '@/schemas/market'

/**
 * Query key factory.
 *
 * Keys are built here rather than inline so invalidation can be expressed at
 * the right granularity: the refresh button on the NEPSE card invalidates
 * `marketKeys.indexSummaries()` and clears every timeframe at once, while a
 * poll tick only touches `marketKeys.indexSummary(range)`.
 */
export const marketKeys = {
  all: ['market'] as const,
  indexSummaries: () => [...marketKeys.all, 'index-summary'] as const,
  indexSummary: (range: IndexRange, indexKey = 'NEPSE') =>
    [...marketKeys.indexSummaries(), indexKey, range] as const,
  tickerTape: () => [...marketKeys.all, 'ticker-tape'] as const,
  indexIntraday: (indexKey = 'NEPSE') => [...marketKeys.all, 'index-intraday', indexKey] as const,
  mood: () => [...marketKeys.all, 'mood'] as const,
  moodHistory: (days: number) => [...marketKeys.all, 'mood-history', days] as const,
  companyLogos: () => [...marketKeys.all, 'company-logos'] as const,
  indices: () => [...marketKeys.all, 'indices'] as const,
  /** One entry per (symbol, bar count) — the countback is part of the answer,
   *  not a hint: a 261-bar read and a 5-bar read of NABIL are different series
   *  and must not share a cache entry. */
  dailyBars: (symbol: string, countback?: number) =>
    [...marketKeys.all, 'daily-bars', symbol, countback ?? 'all'] as const,
}
